import { Link } from "react-router-dom";
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { useLanguage } from "@/contexts/LanguageContext";
import { textosSalud } from "@/lib/healthConsent";
import { rutaPrivacidad } from "@/lib/legalPaths";

/** Casilla de consentimiento explícito para los datos de salud de las notas (art. 9.2.a RGPD) */
export const HealthConsentField = <T extends FieldValues>({
  control,
  name,
}: {
  control: Control<T>;
  name: FieldPath<T>;
}) => {
  const { language } = useLanguage();
  const t = textosSalud(language);
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0">
          <FormControl>
            <Checkbox checked={field.value} onCheckedChange={field.onChange} />
          </FormControl>
          <div className="space-y-1 leading-snug">
            <FormLabel className="font-normal">
              {t.casilla}{" "}
              <Link
                to={`${rutaPrivacidad(language)}#datos`}
                target="_blank"
                className="text-primary underline underline-offset-4"
              >
                {t.masInfo}
                <span className="sr-only"> {t.pestanaNueva}</span>
              </Link>
            </FormLabel>
            <FormMessage />
          </div>
        </FormItem>
      )}
    />
  );
};
